import * as types from '../actionTypes';

const initialState = {
  // Folders will be a flat list. Hierarchy is determined by parentId.
  // Each folder: { id, name, keywords: Array<{id, text, ...any other original keyword props like data}>, parentId: string | null }
  folders: [],
};

export const getInitialFolderState = () => ({ ...initialState });

const folderReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.RESTORE_STATE:
      if (action.payload && action.payload.folders) {
        const loadedFoldersState = action.payload.folders;
        if (Array.isArray(loadedFoldersState.folders)) {
          const restoredFolders = loadedFoldersState.folders.map(folder => ({
            ...folder,
            keywords: folder.keywords || [],
            isExpanded: folder.isExpanded === undefined ? true : folder.isExpanded, // Default to true if undefined
            // parentId should ideally always be present (null or string)
          }));
          return { ...initialState, ...loadedFoldersState, folders: restoredFolders };
        }
      }
      return state;

    case types.ADD_FOLDER:
      const { folderName, parentId } = action.payload;
      const newFolder = {
        id: `folder-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
        name: folderName,
        keywords: [],
        parentId: parentId,
        isExpanded: parentId === null, // Expand top-level folders by default
      };
      return {
        ...state,
        folders: [...state.folders, newFolder],
      };

    case types.ASSIGN_KEYWORD_TO_FOLDER:
      const { folderId, keywordItem } = action.payload; // keywordItem is {id, text, isActive, data}
      return {
        ...state,
        folders: state.folders.map(folder => {
          if (folder.id === folderId) {
            if (!folder.keywords.find(kw => kw.id === keywordItem.id)) {
              return {
                ...folder,
                // Store the relevant parts of keywordItem, not necessarily the whole thing
                // if keywordItem contains transient/UI-specific state not needed in the folder.
                // For now, storing what KeywordItem provides.
                keywords: [...folder.keywords, { id: keywordItem.id, text: keywordItem.text, data: keywordItem.data }],
              };
            }
          }
          return folder;
        }),
      };

    case types.ASSIGN_MULTIPLE_KEYWORDS_TO_FOLDER: {
      const { folderId, keywordObjects } = action.payload; // keywordObjects is an array of {id, text, data}
      return {
        ...state,
        folders: state.folders.map(folder => {
          if (folder.id === folderId) {
            const newKeywordsForFolder = [...folder.keywords];
            keywordObjects.forEach(kwObj => {
              if (!newKeywordsForFolder.find(existingKw => existingKw.id === kwObj.id)) {
                newKeywordsForFolder.push({ id: kwObj.id, text: kwObj.text, data: kwObj.data });
              }
            });
            return { ...folder, keywords: newKeywordsForFolder };
          }
          return folder;
        }),
      };
    }

    // Ensure that if keywords are deleted/modified in keywordReducer,
    // folders holding these keywords reflect this if necessary.
    // For now, keywords in folders are just copies of {id, text, data}.
    // If a keyword is "deleted" (isDeleted=true), it still exists in folders.
    // This might be desired, or a more complex cleanup action could be dispatched.

    case types.TOGGLE_FOLDER_EXPAND:
      return {
        ...state,
        folders: state.folders.map(folder =>
          folder.id === action.payload // payload is folderId
            ? { ...folder, isExpanded: !folder.isExpanded }
            : folder
        ),
      };

    default:
      return state;
  }
};

export default folderReducer;
